import { hotBettings } from '@/mocks/home';

export default function HotBettingSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100/70">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="text-xs font-bold text-accent-500 uppercase tracking-wider">Hot Picks</span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mt-2">
            热门竞猜推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">
            精选全球热门赛事竞猜项目，专业数据分析，不错过每一个精彩瞬间
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {hotBettings.map((bet) => (
            <div
              key={bet.id}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-accent-200 transition-all duration-300"
            >
              <div className="p-5">
                <div className="flex items-center justify-between mb-3">
                  <h3 className="font-bold text-foreground-900 text-base">{bet.title}</h3>
                  <span className="text-[10px] font-bold text-primary-500 bg-primary-50 px-2.5 py-1 rounded-full">
                    {bet.hotTag}
                  </span>
                </div>
                <p className="text-sm text-foreground-500 mb-4">{bet.description}</p>
                <div className="flex flex-col gap-2">
                  {bet.options.map((opt) => (
                    <div
                      key={opt.label}
                      className="flex items-center justify-between py-2.5 px-3 rounded-lg bg-background-100/70 hover:bg-accent-50 transition-colors cursor-pointer group"
                    >
                      <span className="text-sm font-medium text-foreground-700 group-hover:text-foreground-900">
                        {opt.label}
                      </span>
                      <span className="font-heading text-sm font-bold text-accent-500 group-hover:text-accent-600">
                        {opt.odds.toFixed(2)}
                      </span>
                    </div>
                  ))}
                </div>
                <div className="flex items-center gap-1.5 mt-4 pt-3 border-t border-background-200/50">
                  <i className="ri-time-line text-xs text-foreground-400"></i>
                  <span className="text-xs text-foreground-400">截止日期：{bet.deadline}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}